import axios, { AxiosRequestConfig } from "axios";
import appconfig from "../../../AppConfig";
import { debug } from "../../../common/utils";
import { LOAD_CATEGORIES_ADMIN } from "../menu.actions";

export const getCategoriesAdminApi = async (dispatch: any) => {
  const config = {
    baseURL: appconfig.baseURL,
  } as AxiosRequestConfig;

  await axios
    .get("/products/getCategoriesAdmin", config)
    .then((response: any) => {
      debug("!!! API - getCategoriesAdmin !!!");

      dispatch({
        type: LOAD_CATEGORIES_ADMIN,
        categories: response.data,
      });

      debug(response);
    })
    .catch((err: any) => {
      console.log(err);
    });
};
